<template>
    <div>
        <el-divider class="el-divider"/>
        <el-row style="margin-top: 2px">
            <span>文件名称：</span>
            <span>{{ propFileName }}</span>
        </el-row>
        <el-row style="margin-top:2px;">
            <el-col :span="9">
                <el-date-picker type="datetime" size="mini" v-model="createTime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="创建日期-默认修改日期" style="width: 100%;">{{propCreateTime}}</el-date-picker>
            </el-col>
            <el-col :span="1" class="line" style="text-align:center;color:#DCDFE6;">-</el-col>
            <el-col :span="14">
                <el-input size="mini" placeholder="备注-默认文件名" v-model="remark"></el-input>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    name: 'ObservationInformation',
    props: {
        propIndex: Number,
        propFileName: String,
        propCreateTime: String,
        propRemark: String
    },
    data(){
        return{
            fileName: this.propFileName,
            createTime: this.propCreateTime,
            remark: this.propRemark
        }
    },
    watch: {
        createTime: function (val) {
            this.$emit('updateCreateTime', val, this.propIndex);
        },
        remark: function (val) {
            this.$emit('updateRemark', val, this.propIndex);
        }
    }
}
</script>
<style scoped>
.el-divider {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0 4px 0;
}
</style>
